import React from "react";

const TaxiRatesOne = () => {
  const cars = [
    {
      name: "Maruti Swift Dzire",
      seats: "4 + 1 Seater",
      perKm: "₹12",
      extraHr: "₹150",
      image: "/images/fleets/1.jpg",
    },
    {
      name: "Scorpio",
      seats: "7 - 9 Seater",
      perKm: "₹18",
      extraHr: "₹150",
      image: "/images/fleets/3.jpg",
    },
    {
      name: "Maruti Ertiga",
      seats: "7 Seater",
      perKm: "₹15",
      extraHr: "₹150",
      image: "/images/fleets/2.jpg",
    },
    {
      name: "Innova Crysta",
      seats: "6 + 1 Seater",
      perKm: "₹20",
      extraHr: "₹150",
      image: "/images/fleets/4.jpg",
    },
    {
      name: "Tavera",
      seats: "6 + 1 Seater",
      perKm: "₹18",
      extraHr: "₹150",
      image: "/images/fleets/5.jpg",
    },
    {
      name: "Mini Bus Traveller",
      seats: "25 - 30 Seater",
      perKm: "₹35",
      extraHr: "₹150",
      image: "/images/fleets/11.jpg",
    },
  ];

  return (
    <section className="taxi-rates-one section-space">
      <div className="container">

        {/* TITLE */}
        <div className="sec-title text-center mb-5">
          <h6 className="sec-title__tagline">Lotus Cab Fleet</h6>
          <h3 className="sec-title__title">
            Our Available Vehicles & Rates
          </h3>
        </div>

        {/* CAR CARDS */}
        <div className="row gutter-y-30">
          {cars.map((car, index) => (
            <div key={index} className="col-lg-4 col-md-6 py-2">
              <div className="lotus-card">

                {/* TOP IMAGE SECTION */}
                <div className="lotus-card__image">
                  <img src={car.image} alt={car.name} />
                </div>

                {/* BOTTOM CONTENT SECTION */}
                <div className="lotus-card__content">
                  <h3 className="lotus-card__title">
                    {car.name}
                  </h3>

                  <p className="lotus-card__brand">
                    Lotus Cab
                  </p>

                  <ul className="lotus-card__list">
                    <li>
                      <span>Seats</span>
                      <span>{car.seats}</span>
                    </li>
                    <li>
                      <span>Per KM Rate</span>
                      <span>{car.perKm}</span>
                    </li>
                    <li>
                      <span>Extra Hr</span>
                      <span>{car.extraHr}</span>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TaxiRatesOne;
